<template>
  <div class="login-wrapper">
    <div class="login-main">
      <!-- <div class="login-title">
        <img src="../logo.png" class="logo-icon" />
      </div> -->
      <van-form>
        <van-field
          v-model="distributeCode"
          type="number"
          name="请输入兑换码"
          maxlength="11"
          placeholder="请输入兑换码"
          class="mobile"
        />
        <van-field
          v-model="mobile"
          type="tel"
          name="手机号"
          maxlength="11"
          placeholder="手机号"
          class="mobile"
        />
        <div class="password">
          <van-field
            v-model="smsCode"
            type="number"
            maxlength="6"
            name="验证码"
            placeholder="六位验证码"
            class="password-input"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                class="password-btn"
                :class="{ active: isSend, canClick: isMobile && !isSend }"
                @click="sendSms"
                >{{ smsText }}</van-button
              >
            </template>
          </van-field>
        </div>
      </van-form>
      <div class="footer">
        <div class="submit-btn" :class="{ active: isSubmit }" @click="onSubmit">
          绑定
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ERROR_OK } from "../../request/http"
import { login, smsCode } from "../../request/api/user"
import { Form, Field, Button, Toast } from "vant"
export default {
  name: "course-list",
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast
  },
  created () {
    this.openid = this.$route.query.openid
  },
  data () {
    return {
      openid: "",
      mobile: "",
      smsCode: "",
      countdown: 60,
      distributeCode: "",
      isSend: false,
      timer: null
    }
  },
  computed: {
    smsText () {
      return this.isSend ? `${this.countdown}s重新获取` : "发送验证码"
    },
    isSubmit () {
      return (
        /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.mobile) &&
        this.smsCode.length === 6 &&
        this.distributeCode
      )
    },
    isMobile () {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.mobile)
    }
  },
  methods: {
    validator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val)
    },
    sendSms () {
      if (/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.mobile) && !this.isSend) {
        smsCode({
          mobile: this.mobile
        }).then(res => {
          if (res.code === ERROR_OK) {
            this.isSend = true
            this.setTime()
          } else {
            Toast.fail({
              type: "fail",
              message: "验证码发送失败，请稍后再试",
              duration: 1000
            })
          }
        })
      }
    },
    setTime () {
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          clearInterval(this.timer)
          this.countdown = 60
          this.isSend = false
        }
        this.countdown--
      }, 1000)
    },
    async onSubmit () {
      if (!this.isSubmit) {
        return
      }
      console.log("submit", this)
      let { code, data, msg } = await login({
        smsCode: this.smsCode,
        openid: this.openid,
        mobile: this.mobile,
        distributeCode: this.distributeCode
      })
      if (code === ERROR_OK) {
        this.$router.push({
          name: "share",
          query: {
            distributorId: data.distributorId,
            distributorType: data.distributorType
          }
        })
      } else {
        Toast.fail({ type: "fail", message: msg, duration: 1000 })
      }
    }
  }
};
</script>
<style lang="less">
.van-field__value {
  height: 100%;
  .van-field__body {
    height: 100%;
    .van-field__control {
      height: 100%;
    }
  }
}
.van-toast__text {
  word-break: break-all;
}
</style>
<style lang="less" scoped>
.login-wrapper {
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  .login-main {
    padding: 120px 70px 0;
    .login-title {
      text-align: center;
      .logo-icon {
        width: 182px;
        height: 206px;
      }
    }
    .mobile {
      display: flex;
      align-items: center;
      width: 100%;
      height: 90px;
      line-height: 1;
      margin-top: 60px;
      padding: 10px 0 10px 40px !important;
      background: #f5f5f5;
      border-radius: 45px;
    }
    .password {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 32px;
      .password-input {
        display: flex;
        align-items: center;
        flex: 1;
        height: 90px;
        line-height: 1;
        padding: 10px 0 10px 40px !important;
        background: #f5f5f5;
        border-radius: 45px;
      }
      .password-btn {
        margin-right: 10px;
        background: transparent;
        border: 1px solid transparent;
        font-family: PingFangSC-Regular;
        font-size: 32px;
        color: #999999;
        &.canClick {
          color: #f78019;
        }
        &.active {
          font-family: PingFangSC-Regular;
          font-size: 32px;
          color: #999999;
        }
      }
    }
  }
  .footer {
    margin-top: 50px;
    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 90px;
      background: #dddddd;
      border-radius: 45px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      &.active {
        background: #ff933b;
        color: #fff;
      }
    }
  }
}
</style>
